import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Rich%20dark%20mahogany%20wood%20surface%20with%20scattered%20mahjong%20tiles%20in%20warm%20golden%20and%20red%20tones%2C%20dramatic%20chiaroscuro%20lighting%2C%20luxurious%20Chinese%20aesthetic%2C%20abstract%20artistic%20composition%20with%20bokeh%20highlights%2C%20elegant%20and%20mysterious%20atmosphere&width=1800&height=900&seq=mahjong-hero-bg&orientation=landscape"
          alt="麻将竞技背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 bg-primary-500/90 text-background-50 px-4 py-1.5 rounded-full text-sm font-medium mb-6">
          <i className="ri-fire-line"></i>
          <span>热点资讯</span>
        </div>

        <h1 className="font-heading text-2xl md:text-5xl font-black text-background-50 leading-tight mb-5">
          麻将糊了中<span className="text-accent-400">17万</span>！真实爆奖案例与技巧全揭秘
        </h1>

        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          深度解析麻将爆奖瞬间背后的规则、牌型组合与高倍奖励机制，带你了解如何在合法娱乐平台上体验麻将竞技的极致乐趣。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => { navigate('/article/majiang-hule-zhong-17wan'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            查看爆奖案例
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
          <button
            onClick={() => { navigate('/category/majiang-jiqiao'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="px-7 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full text-sm border border-background-50/30 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            学习麻将技巧
          </button>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          {[
            { value: '10万+', label: '月活跃读者' },
            { value: '500+', label: '原创文章' },
            { value: '50+', label: '合作平台' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}